import './index.scss'
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { Box, Stepper, Step, StepLabel, Button, StepIcon } from '@mui/material';
import { styled } from '@mui/system';
import Loading from '../../components/common/loading.js';
import { useTranslation } from 'react-i18next';
import ClientInformation from '../taxQuestionnaire/clientInformation/index.js';
import RefundDetails from '../taxQuestionnaire/refundDetails/index.js';
import Submission from '../taxQuestionnaire/submission/index.js';
import TravelHistory from '../taxQuestionnaire/travelHistory/index.js';
import TaxSummary from '../taxQuestionnaire/taxSummary/index.js';
import { userInfo } from '../../redux/slice';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { get, post } from '../../util/request';
import { Form } from 'antd';
import BankAccountSubmitSuccessPopUp from '../bankAccount/bankAccountSubmitSuccessPopUp';

export default TaxFilingQuestionnaire; function TaxFilingQuestionnaire() {
    const { t } = useTranslation();
    const user = useSelector(userInfo);
    const [activeStep, setActiveStep] = useState(0);
    const initialSteps = sessionStorage.getItem('taxAction') === 'Pay' ? ['Submission'] : ['Client Information', 'Refund Details', 'US Immigration & Travel', 'Submission'];
    const [steps, setSteps] = useState(initialSteps);
    const [completedSteps, setCompletedSteps] = useState(new Set());
    const [taxFilingQuestionnaire, setTaxFilingQuestionnaire] = useState({});
    const [country, setCountry] = useState([]);
    const [eligible, setEligible] = useState(true);
    const [nextButtonStatus, setNextButtonStatus] = useState(false);
    const formRef = useRef();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [modalProperty, setModalProperty] = useState({ isModalOpen: false, title: '', content: '', icon: '' });
    const history = useHistory();
    const [notEligibleReason, setNotEligibleReason] = useState('');
    const [notEligbleSPT, setNotEligbleSPT] = useState(false);
    const previewDetail = JSON.parse(sessionStorage.getItem('previewDetail'));

    useEffect(() => {
      const pd = JSON.parse(sessionStorage.getItem('previewDetail'));
      const isClientView = (pd !== null && pd?.sfUserType === 'CL') ||
        (pd === null && user?.sfUserType === 'CL');
      const hasActiveInv = pd !== null ? pd?.hasActiveInvestment : user?.hasActiveInvestment;
      if (isClientView && hasActiveInv === false) {
        history.push(history.location.pathname.startsWith('/preview/') ? '/preview/document' : '/document');
      }
    }, []);
    //Stepper Design
    const CustomStepIcon = styled(StepIcon)(({ theme }) => ({
        width: 37,
        height: 37,
        '& .MuiStepIcon-circle': {
            width: 37,
            height: 37,
            borderRadius: '50%'
        },
    }));

    const MS_PER_DAY = 24 * 60 * 60 * 1000;

    function daysBetween(start, end) {
        const daysPerYear = getDaysPerYear(start, end);
        return Object.values(daysPerYear).reduce((sum, days) => sum + days, 0);
    }

    function getDaysPerYear(startDate, endDate) {
        const result = {};
        const start = new Date(startDate);
        const end = new Date(endDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        const endExclusive = new Date(end.getTime() + MS_PER_DAY);

        const startYear = start.getFullYear();
        const endYear = end.getFullYear();

        for (let year = startYear; year <= endYear; year++) {
            const yearStart = new Date(year, 0, 1);
            const yearEndExclusive = new Date(year + 1, 0, 1);
            const rangeStart = new Date(Math.max(start.getTime(), yearStart.getTime()));
            const rangeEnd = new Date(Math.min(endExclusive.getTime(), yearEndExclusive.getTime()));

            if (rangeEnd > rangeStart) {
                const days = (rangeEnd - rangeStart) / (MS_PER_DAY);
                result[year] = days;
            }
        }
        return result;
    }

    //Set up
    const setup = async () => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId,
            year: sessionStorage.getItem('taxYear'),
            clientId: (user?.sfUserType === 'CL' ? user.clientID : previewDetail?.clientId)
        }
        await get('/taxQuestionnaire/detail', params).then((data) => {
            var day = data?.DateOfBirth.slice(8, 10)
            var year = data?.DateOfBirth.slice(0, 4)
            var month = data?.DateOfBirth.slice(5, 7)
            data.DateOfBirth = year + ' / ' + month + ' / ' + day;
            if (data.TaxMailingCountry === '') {
                data.TaxMailingCountry = (user?.sfUserType === 'CL' ? user?.country : previewDetail?.country);
            }

            data.PhoneNumber = data.PhoneNumber === '' ? null : data.PhoneNumber;

            setTaxFilingQuestionnaire(data);

            formRef.current?.setFieldsValue(data);
            let currentYear = 0;
            let totalDaysLastYear = 0;
            let totalDaysLast2Years = 0;

            data?.USStays?.map((item) => {
                const year = getDaysPerYear(item.FromDate, item.ToDate);
                currentYear = currentYear + (year[data.TaxFilingYear] ?? 0);
                totalDaysLastYear = totalDaysLastYear + (year[data.TaxFilingYear - 1] ?? 0);
                totalDaysLast2Years = totalDaysLast2Years + (year[data.TaxFilingYear - 2] ?? 0);
            });

            const sptDays = currentYear + (totalDaysLastYear / 3) + (totalDaysLast2Years / 6) > 183;




            if (data.CountryOfTaxResidency === 'USA' || data.OtherUSIncomeSource === 'Yes' || (data.CountryOfNationality === 'USA' || data.CountryOfNationality === 'United States')) {
                setSteps(['Client Information']);
                setEligible(false);
            }
            else if (data.ActiveGreenCardHolder === 'Yes' || data.ActiveUSCitizen === 'Yes' || (sptDays && currentYear > 30)) {
                setSteps(['Client Information', 'Refund Details', 'US Immigration & Travel']);
                setEligible(false);
            }
            else {
                setEligible(true);
            }


            setLoading(false);

        }).catch(() => {
            setLoading(false);
        });
        setLoading(false);
    }



    const getCountryOption = async () => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId
        };
        const data = await get('/appUser/profile/country', params);
        if (data) {
            if (data.length > 0) {
                setCountry(data);
            }
        }
    };

    useEffect(() => {
        getCountryOption();
        setup();
    }, []);

    useEffect(() => {
        getCountryOption();
    }, [window.localStorage.lang]);


    const handleStep = (step) => {
        if (completedSteps.has(step) && !(activeStep === steps.length)) {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            setActiveStep(step);
        }
    };

    const handleBack = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleNext = () => {
        if (taxFilingQuestionnaire.Status === '' || taxFilingQuestionnaire?.Status?.toLowerCase() === 'new') {
            formRef?.current
                ?.validateFields()
                .then(() => {
                    const errorList = document.querySelectorAll(".error-message")
                    if (errorList.length === 0) {
                        if (activeStep < steps.length) {
                            setLoading(true);
                            handleSubmit();
                        }
                    } else {
                        const errorList = document.querySelectorAll(".error-message")
                        errorList[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    }
                })
                .catch((err) => {
                    const errorList = document.querySelectorAll(".ant-form-item-has-error")
                    errorList[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' })
                });
        }
        else {
            handleNextStep();
        }
    };

    const handleNextStep = async () => {
        if (((activeStep === steps.length - 1) && !(taxFilingQuestionnaire.Status === '' || taxFilingQuestionnaire?.Status?.toLowerCase() === 'new'))) {
            goto();
        }
        else {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            const newCompletedSteps = new Set(completedSteps);
            newCompletedSteps.add(activeStep);
            setCompletedSteps(newCompletedSteps);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    const handleSubmit = async () => {
        if (user?.sfUserType === 'CL') {
            const tab = steps[activeStep];
            const detail = formRef.current?.getFieldsValue();
            detail.TaxFilingYear = taxFilingQuestionnaire.TaxFilingYear;
            detail.CustomerID = taxFilingQuestionnaire.CustomerID;

            detail.Tab = tab;
            if (tab === 'US Immigration & Travel') {
                detail.USStays = taxFilingQuestionnaire.USStays;
                detail.PeriodStayedInUSCurrentYear = taxFilingQuestionnaire.PeriodStayedInUSCurrentYear;
                detail.PeriodStayedInUSLastYear = taxFilingQuestionnaire.PeriodStayedInUSLastYear;
                detail.PeriodStayedInUSTwoYearsAgo = taxFilingQuestionnaire.PeriodStayedInUSTwoYearsAgo;
            }
            else if (tab === 'Submission') {
                detail.SignatureFile = taxFilingQuestionnaire.SignatureFile;
            }

            const params = {
                ...detail,
                accessToken: user.accessToken,
                userId: user.userId
            }

            await post('/taxQuestionnaire/update', params).then((data) => {
                if (data.message === 'Success') {
                    handleNextStep();
                }
                else {
                    setModalProperty({
                        isModalOpen: true,
                        icon: 'submit-error',
                        title: 'Error',
                        content: 'Error in submission. Please try again.'
                    });
                    setLoading(false);
                }
            }).catch(() => {
                setModalProperty({
                    isModalOpen: true,
                    icon: 'submit-error',
                    title: 'Error',
                    content: 'Error in submission. Please try again.'
                });
                setLoading(false);
            });
        }
        else {
            handleNextStep();
        }
        setLoading(false);
    }

    useEffect(() => {
        if (activeStep === steps.indexOf('Submission')) {
            if (user?.sfUserType === 'CL') {
                if (taxFilingQuestionnaire.Status === '' || taxFilingQuestionnaire?.Status?.toLowerCase() === 'new') {
                    setNextButtonStatus(true);
                }
                else {
                    setNextButtonStatus(false);
                }
            }
            else {
                setNextButtonStatus(false);
            }
        }
        else if (activeStep === steps.indexOf('US Immigration & Travel')) {
            if (taxFilingQuestionnaire.ActiveGreenCardHolder === 'Yes' || taxFilingQuestionnaire.ActiveUSCitizen === 'Yes') {
                setNextButtonStatus(false);
            }
            else {
                if (taxFilingQuestionnaire.VisitedUSPast3Years === 'Yes' && taxFilingQuestionnaire.USStays.length === 0) {
                    setNextButtonStatus(true);
                }
                else {
                    setNextButtonStatus(false);
                }
            }
        }
        else {
            setNextButtonStatus(false);
        }
    }, [activeStep, steps])

    const handleSignatureChange = async (status, image) => {
        setNextButtonStatus(status);
        if (!status) {
            handleChangeTaxFilingQuestionnaire('SignatureFile', image);
        }
    }

    const handleTravelDateChange = async (total, validTravelDates) => {
        if (!(taxFilingQuestionnaire.ActiveUSCitizen === 'Yes' || taxFilingQuestionnaire.ActiveGreenCardHolder === 'Yes')) {
            if ((validTravelDates.length > 0 && taxFilingQuestionnaire.VisitedUSPast3Years === 'Yes')) {
                setNextButtonStatus(false);
            }
            else {
                setNextButtonStatus(true);
            }

            if (total.SPTDays >= 183 && total.periodStayCurrentYear > 30) {
                setSteps(['Client Information', 'Refund Details', 'US Immigration & Travel']);
                setEligible(false);
                setNotEligibleReason('TravelHistory');
                setNotEligbleSPT(true);
            }
            else {
                setSteps(initialSteps);
                setEligible(true);
                setNotEligibleReason('');
                setNotEligbleSPT(false);
            }

            setTaxFilingQuestionnaire(prevData => ({
                ...prevData,
                PeriodStayedInUSCurrentYear: total.periodStayCurrentYear,
                PeriodStayedInUSLastYear: total.periodStayLastYear,
                PeriodStayedInUSTwoYearsAgo: total.periodStayLast2Years,
                USStays: validTravelDates
            }));
        }
    }

    const handleChangeTaxFilingQuestionnaire = async (key, value) => {
        setTaxFilingQuestionnaire(prevData => ({
            ...prevData,
            [key]: value
        }));
        formRef?.current.setFieldValue(key, value);

        if (key !== 'SignatureFile') {
            if ((key === 'ActiveGreenCardHolder' && value === 'Yes') || (key === 'ActiveUSCitizen' && value === 'Yes')) {
                setNotEligibleReason('USResident');
                setSteps(['Client Information', 'Refund Details', 'US Immigration & Travel']);
                setEligible(false);
            }
            else if (key === 'BeenGreenCardHolder' && (value === 'No' || value === '')) {
                if (notEligbleSPT) {
                    setNotEligibleReason('TravelHistory');
                    setSteps(['Client Information', 'Refund Details', 'US Immigration & Travel']);
                    setEligible(false);
                }
                else {
                    formRef?.current.setFieldValue('ActiveGreenCardHolder', '');
                    setNotEligibleReason('');
                    setEligible(true);
                    setSteps(initialSteps);
                }
            }
            else if (key === 'CountryOfTaxResidency' && (value === 'USA' || value === '')) {
                setSteps(['Client Information']);
                setEligible(false);
                setNotEligibleReason('USResident');
            }
            else if (key === 'OtherUSIncomeSource' && (value === 'Yes' || value === '')) {
                setSteps(['Client Information']);
                setEligible(false);
                setNotEligibleReason('OtherSourceOfIncome');
            } else if (key === 'BeenUSCitizen' && (value === 'No' || value === '')) {
                if (notEligbleSPT) {
                    setNotEligibleReason('TravelHistory');
                    setSteps(['Client Information', 'Refund Details', 'US Immigration & Travel']);
                    setEligible(false);
                }
                else {
                    formRef?.current.setFieldValue('ActiveUSCitizen', '');
                    setNotEligibleReason('');
                    setEligible(true);
                    setSteps(initialSteps);
                }
            } else if (key === 'CountryOfNationality' && ((value === 'USA' || value === 'United States'))) {
                setSteps(['Client Information']);
                setEligible(false);
                setNotEligibleReason('USResident');
            }
            else {
                if (formRef?.current.getFieldValue('ActiveUSCitizen') === 'Yes' || formRef?.current.getFieldValue('ActiveGreenCardHolder') === 'Yes') {
                    setNotEligibleReason('USResident');
                    setSteps(['Client Information', 'Refund Details', 'US Immigration & Travel']);
                    setEligible(false);
                }
                else if (notEligbleSPT) {
                    setNotEligibleReason('TravelHistory');
                    setSteps(['Client Information', 'Refund Details', 'US Immigration & Travel']);
                    setEligible(false);
                }
                else {
                    setNotEligibleReason('');
                    setSteps(initialSteps);
                    setEligible(true);
                }
            }
        }
    }

    const goto = () => {
        history.push({
            pathname: user?.sfUserType === 'CL' ? '/questionnaires' : '/preview/questionnaires'
        });
    }



    return (<>
        {
            ((user?.sfUserType === 'CL' && user?.hasTaxQuestionnaire) || (previewDetail.sfUserType === 'CL' && previewDetail?.hasTaxQuestionnaire)) && (<>
                {loading && <Loading />}
                <BankAccountSubmitSuccessPopUp isModalOpen={modalProperty.isModalOpen} icon={modalProperty.icon} title={t(modalProperty.title)} content={t(modalProperty.content)} handleOk={goto} />
                <div className='tax-filing-questionnaire-container'>
                    <div className='main-box stepper'>
                        <Form autoComplete="off" ref={formRef} scrollToFirstError>
                            <Box sx={{ width: '1446px' }}>
                                <Stepper activeStep={activeStep} alternativeLabel>
                                    {steps.map((label, index) => {
                                        const stepProps = {};
                                        const labelProps = {};

                                        if (completedSteps.has(index) && activeStep !== index) {
                                            stepProps.completed = true;
                                        }


                                        return (
                                            <Step key={label} {...stepProps} onClick={() => handleStep(index)}>
                                                <StepLabel {...labelProps} StepIconComponent={index === activeStep ? CustomStepIcon : null}>{t(label)}</StepLabel>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                                {//Summary Tab
                                    activeStep === steps.length ? (
                                        <>
                                            {
                                                steps.length > 0 ? (<>
                                                    <React.Fragment>
                                                        <div className='content'>
                                                            <TaxSummary Eligible={eligible} NotEligibleReason={notEligibleReason} />
                                                        </div>
                                                    </React.Fragment>
                                                </>) : <Loading />
                                            }
                                        </>
                                    ) : (
                                        <React.Fragment>
                                            <div className='content'>
                                                {//Client Information
                                                    activeStep === steps.indexOf('Client Information') && (<>
                                                        <ClientInformation Country={country} TaxFilingQuestionnaire={taxFilingQuestionnaire} HandleTaxFilingQuestionnaireSave={handleChangeTaxFilingQuestionnaire} />
                                                    </>)
                                                }
                                                {//Tax Filing Fees
                                                    activeStep === steps.indexOf('Refund Details') && (<>
                                                        <RefundDetails TaxFilingQuestionnaire={taxFilingQuestionnaire} Country={country} />
                                                    </>)
                                                }
                                                {//Travel History
                                                    activeStep === steps.indexOf('US Immigration & Travel') && (<>
                                                        <TravelHistory HandleTravelDateChange={handleTravelDateChange} TaxFilingQuestionnaire={taxFilingQuestionnaire} HandleTaxFilingQuestionnaireSave={handleChangeTaxFilingQuestionnaire} />
                                                    </>)
                                                }
                                                {//Methods to receive tax refund
                                                    activeStep === steps.indexOf('Submission') && (<>
                                                        <Submission handleSignatureSave={handleSignatureChange} TaxFilingQuestionnaire={taxFilingQuestionnaire} />
                                                    </>)
                                                }

                                            </div>
                                            <div className='footer'>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                                    {
                                                        sessionStorage.getItem('taxAction') !== 'Pay' && (<>
                                                            <Button
                                                                color="inherit"
                                                                disabled={activeStep === 0}
                                                                onClick={handleBack}
                                                                sx={{ mr: 1 }}
                                                                id='back-button'
                                                            >
                                                                {t('BACK')}
                                                            </Button>
                                                        </>)
                                                    }
                                                    <Box sx={{ flex: '1 1 auto' }} />
                                                    {
                                                        sessionStorage.getItem('taxAction') === 'Pay' ? (<>
                                                            <Button onClick={goto} id='next-button' className={activeStep === steps.length - 1 ? "confirm-button" : ""}>
                                                                {t('Close')}
                                                            </Button>
                                                        </>) : (<>
                                                            <Button htmlType={"submit"} onClick={handleNext} id='next-button' className={activeStep === steps.length - 1 ? "confirm-button" : ""} disabled={nextButtonStatus}>
                                                                {activeStep === steps.length - 1 ? (taxFilingQuestionnaire?.Status?.toLowerCase() === 'new' ? (eligible ? (user?.sfUserType === 'CL' ? t('CONFIRM AND SIGN') : t('CONFIRM')) : t('CONFIRM')) : t('Close')) : t('NEXT')}
                                                            </Button>
                                                        </>)
                                                    }
                                                </Box>
                                            </div>
                                        </React.Fragment>
                                    )}
                            </Box>
                        </Form>
                    </div>
                </div>
            </>)
        }
    </>);
};